import React from "react";
import SignInComponent from "../../Components/SignInComponent/SignInComponent";

const Login = () => {
  return (
    <React.Fragment>
      <SignInComponent />
    </React.Fragment>
  );
};

export default Login;
